import React from "react";
import Table from "@Components/Acc/Table";
import Screenshot from "@Components/Acc/Screenshot";
import { Divider } from "@fluentui/react-northstar";
import { FbAcc } from "@interfaces/acc";
import styles from "./home.module.scss";
import Info from "./Acc/Info";


const Home = ()=>{
    const [user_acc,set_user_acc] = React.useState<FbAcc|undefined>(undefined);
    return (
        <div id={styles.home}>
            <h2>Facebook Manager</h2>
            <div id={styles.table}>
                <Table
                    onClickUser={set_user_acc}
                />
            </div>
            <Divider vertical />
            { user_acc && <Screenshot user_acc={user_acc.fb_acc} /> }
            <Divider vertical />
            { user_acc && <Info user_acc={user_acc} /> }
        </div>
    )
}


export default Home;
